/**
 * BIDC message type strings. Aligns with PHP parent and avoids typos.
 */
export const BIDC_MESSAGE_TYPES = {
  REFRESH_SITE_MAIN_BANNERS: "refreshSiteMainBanners",
  RELOAD: "reload",
  SET_THEME: "setTheme",
  SET_AVAILABLE_HEIGHT: "setAvailableHeight",
  SET_HISTORY: "setHistory",
  HEIGHT_UPDATE: "heightUpdate",
  IFRAME_HEIGHT: "iframe-height",
  GET_AVAILABLE_HEIGHT: "getAvailableHeight",
  GET_HEIGHT: "getHeight",
  SET_OVERLAYS_VISIBLE: "setOverlaysVisible",
  READY: "ready",
  PING: "ping",
  HEALTH_CHECK: "healthCheck",
  DRAWER_MESSAGE: "drawer-message",
  ESTIMATE_SELECTED: "estimateSelected",
  SELECT_VISIT: "selectVisit",
  CLOSE_MODAL: "closeModal",
  MODAL_READY: "modalReady",
  DATE_CHANGED: "dateChanged",
  THEME_MODE_CHANGED: "themeModeChanged",
  SHORTCUT_COMMAND: "shortcutCommand",
} as const;

export type BidcMessageType =
  (typeof BIDC_MESSAGE_TYPES)[keyof typeof BIDC_MESSAGE_TYPES];
